import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { accountAPI, transactionAPI } from "services";
import Txn from "./Txn";
import { HeaderShimmer, ListHeader, OpenCloseBalance, ShimmerLoader } from "components";
import { Loader } from "components";
import { formatMoney } from "utils";
import Header from "./Header";
import Footer from "./Footer";
import NoAccount from "./NoAccount";
import useUniversalStore from "store/universalStore";

const PublicKhata = () => {
  const { id } = useParams();

  // State variables to hold various data
  const [txns, setTxns] = useState([]);  // Store transactions
  const [account, setAccount] = useState(null);  // Store account details
  const [openBalance, setOpenBalance] = useState(0);  // Store opening balance for the selected month
  const [closeBalance, setCloseBalance] = useState(0);  // Store closing balance for the selected month
  const [loading, setLoading] = useState(true);  // State to manage loading state
  const [animation, setAnimation] = useState("");  // Animation class for the transaction view
  const [monthlyCash, setMonthlyCash] = useState({
    in: 0,
    out: 0
  });
  const selectedMonth = useUniversalStore((state) => state.selectedMonth);

  // Fetch data when component is mounted or ID changes
  useEffect(() => {
    fetchData();
    fetchTxnByDate();
    monthlyCashInOut();
  }, [selectedMonth]);

  // Fetch account details by account ID
  const fetchData = async () => {
    const result = await accountAPI.getAccountById(id);
    if (result) setAccount(result);
  };

  // Fetch transactions and balance data for the selected month
  const fetchTxnByDate = async () => {
    const monthStartDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1, 0, 0, 0, 0);
    const monthEndDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0, 23, 59, 59, 999);

    try {
      setLoading(true);  // Start loading state
      const results = await transactionAPI.getTransactionsByAccountIdWithMonth(id, selectedMonth);  // Fetch transactions
      const openBalance = await transactionAPI.sumTillDateByAccount(monthStartDate, id);  // Fetch opening balance
      const closeBalance = await transactionAPI.sumTillDateByAccount(monthEndDate, id);  // Fetch closing balance
      setTxns(results);  // Store transactions

      setOpenBalance(openBalance);  // Store opening balance
      setCloseBalance(closeBalance);  // Store closing balance
    } catch (error) {
      console.error("Error fetching transactions", error);
    } finally {
      setLoading(false);  // Set loading state to false once data is fetched
    }
  };

  const monthlyCashInOut = async () => {
    console.log(id + " " + selectedMonth);
    transactionAPI.monthlyCashInOut(id, selectedMonth, "in")
      .then((res) => {
        setMonthlyCash({
          ...monthlyCash,
          in: formatMoney(Math.abs(res))
        });
      });
    transactionAPI.monthlyCashInOut(id, selectedMonth, "out")
      .then((res) => {
        setMonthlyCash({
          ...monthlyCash,
          out: formatMoney(Math.abs(res))
        });
      });
  }

  // if (loading && !account) return <Loader />;

  if (!loading && !account) return <NoAccount />;

  return (
    <>
      <Header
        account={account}
        month={selectedMonth}
        setAnimation={setAnimation} />

      <div className={`row background ${animation}`}
        onAnimationEnd={() => setAnimation("")}>
        {loading ? (
          <>
            <div className="col-6 col-md-6 list-group list-group-flush scrollbar-design h-100 px-3">
              <div className="shimmer-container">
                <HeaderShimmer />
                {[...Array(6)].map((_, i) => <ShimmerLoader key={i} />)}
              </div>
            </div>
            <div className="col-6 col-md-6 list-group list-group-flush scrollbar-design h-100 px-3">
              <div className="shimmer-container">
                <HeaderShimmer />
                {[...Array(6)].map((_, i) => <ShimmerLoader key={i} />)}
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Incoming transactions */}
            <div className="col-6 list-group list-group-flush overflow-scroll scrollbar-design"
              style={{ height: 'calc(100vh - 175px)', maxHeight: 'calc(100vh - 175px)' }}>
              <ListHeader type="in" amount={monthlyCash.in} />
              <OpenCloseBalance type="open" sum={openBalance} />
              {txns?.filter((txn) =>
                txn.get("amount") > 0 && !txn.get("cancelled")).map((txn, i) =>
                  <Txn data={txn} key={i} />
                )}
            </div>
            {/* Outgoing transactions */}
            <div className="col-6 list-group list-group-flush overflow-scroll scrollbar-design"
              style={{ height: 'calc(100vh - 175px)', maxHeight: 'calc(100vh - 175px)' }}>
              <ListHeader type="out" amount={monthlyCash.out} />
              {txns?.filter((txn) =>
                txn.get("amount") < 0 && !txn.get("cancelled")).map((txn, i) =>
                  <Txn data={txn} key={i} />
                )}
              <OpenCloseBalance type="close" sum={closeBalance} />
            </div>
          </>
        )}
      </div>

      <Footer id={id} account={account} />
    </>
  );
};

export default PublicKhata;
